import React from 'react'
import styled from 'styled-components'
import { Gear } from 'phosphor-react'

const Launcher = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;
    border: 1px solid #e7e5e4;
    border-radius: 14px;
    padding: 16px 18px;
    margin-bottom: 12px;
    gap: 16px;

    @media (max-width: 720px) {
        flex-direction: column;
        align-items: stretch;
    }
`

const TitleRow = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 6px;
    font-weight: 600;
    font-size: 15px;
    letter-spacing: -0.02em;
    color: #1c1917;
`

const SourcePill = styled.span`
    font-size: 10px;
    font-weight: 700;
    letter-spacing: 0.04em;
    text-transform: uppercase;
    padding: 3px 8px;
    border-radius: 999px;
    background: #e7eeff;
    color: #1e3a8a;
`

const Summary = styled.div`
    color: #78716c;
    font-size: 13px;
    line-height: 1.45;
`

const PreviewBadge = styled.span`
    display: inline-block;
    padding: 2px 8px;
    border-radius: 8px;
    margin-left: 4px;
    font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
    font-size: 12.5px;
    background: #f3f1ec;
    color: #1c1917;
    word-break: break-all;
`

const ConfigureButton = styled.button`
    background: #fff;
    border: 1px solid #1e3a8a;
    color: #1e3a8a;
    height: 36px;
    padding: 0 12px;
    border-radius: 999px;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    white-space: nowrap;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    flex-shrink: 0;

    &:hover {
        background: #e7eeff;
    }

    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }

    @media (max-width: 720px) {
        width: 100%;
    }
`

const VARIANT_META = {
    inspection: {
        title: 'Inspection Name Format',
        summary:
            'Used when "Start Inspection" creates a new audit. Current:',
        previewLabel: null,
    },
    pdf: {
        title: 'PDF File Name Format',
        summary: 'Applied when a PDF report is generated for an audit. Preview:',
        previewLabel: null,
    },
    emailSubject: {
        title: 'Share Report Email Subject Format',
        summary:
            'Subject line for share-report emails (manual + auto-from-group). Currently:',
        previewLabel: null,
    },
}

export const NameFormatLauncher = ({
    variant = 'inspection',
    preview,
    sourceLabel,
    onConfigure,
    disabled,
}) => {
    const meta = VARIANT_META[variant] || VARIANT_META.inspection
    const isPdf = variant === 'pdf'

    return (
        <Launcher>
            <div>
                <TitleRow>
                    {meta.title}
                    {isPdf && sourceLabel && (
                        <SourcePill>{sourceLabel}</SourcePill>
                    )}
                    {variant === 'emailSubject' && sourceLabel && (
                        <SourcePill>{sourceLabel}</SourcePill>
                    )}
                </TitleRow>
                <Summary>
                    {meta.summary}{' '}
                    <PreviewBadge>{preview}</PreviewBadge>
                </Summary>
            </div>
            <ConfigureButton
                type="button"
                onClick={onConfigure}
                disabled={disabled}
            >
                <Gear size={16} />
                Configure Format
            </ConfigureButton>
        </Launcher>
    )
}
